const gameParamater = require('../define/gameParamater').default;
const playerParamater = require('../define/player').default;
const player = require('../define/player').default;
const { APP_REBOOT, START_GAME, STAGE_INIT, STAGE_CONTINUE, STAGE_CLEAR, GAME_OVER, GAME_PAUSE, GAME_RESUME, END_COOL_TIME, PLACEMENT_SKILL } = require("./actions");

// ============================


const initialState = {
    playerCharactor: "",
    playerName: "",
    playerJobName: "",
    playerSkill: null,
    playerSkillName: "",
    playerSkillCoolTime: 0,
    playerSkillArea: "",
    playerSkillDamage: 0,
    canSkill: true,
    baseTime: undefined,
    startedAt: undefined,
    stoppedAt: undefined,
};

export function playerState(state = initialState, action) {
    // console.log(`# playerState: ${JSON.stringify(state)} -> ${JSON.stringify(action)}`);
    switch (action.type) {
        case APP_REBOOT:
            return initialState;
        case START_GAME:
            const playerData = player.getPlayerData(action.playerCharactor);
            return {
                playerCharactor: action.playerCharactor,
                playerName: action.playerName,
                playerJobName: playerData.playerName,
                playerSkill: playerData.skill,
                playerSkillName: playerData.skillName,
                playerSkillCoolTime: playerData.skillCoolTime,
                playerSkillArea: playerData.skillArea,
                playerSkillDamage: playerData.skillDamage,
                canSkill: false,
                baseTime: undefined,
                startedAt: undefined,
                stoppedAt: undefined,
            }
        case STAGE_INIT:
            return {
                ...state,
                baseTime: 0,
                startedAt: state.startedAt ? action.now : undefined,
                stoppedAt: state.stoppedAt ? action.now : undefined,
                canSkill: true
            }
        case STAGE_CONTINUE:
            return {
                ...state,
                baseTime: 0,
                startedAt: state.startedAt ? action.now : undefined,
                stoppedAt: state.stoppedAt ? action.now : undefined,
                canSkill: true
            }
        case STAGE_CLEAR:
            return {
                ...state,
                stoppedAt: action.now
            }
        case GAME_OVER:
            return {
                ...state,
                stoppedAt: action.now
            }
        case GAME_PAUSE:
            return {
                ...state,
                stoppedAt: action.now
            }
        case GAME_RESUME:
            return {
                ...state,
                baseTime: action.skillBaseTime,
                startedAt: action.now,
                stoppedAt: undefined,
            }
        case END_COOL_TIME:
            return {
                ...state,
                stoppedAt: undefined,
                canSkill: true
            }
        case PLACEMENT_SKILL:
            return {
                ...state,
                baseTime: 0,
                startedAt: action.now,
                stoppedAt: undefined,
                canSkill: false
            }

        default:
            return state;
    }
}